module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 4-d99e4ff888d9b507d70a6d6c5dbdd810.jpg";